export default "__VITE_ASSET__oviVAH2G__"